module.exports = __webpack_public_path__ + "files/cde11f453400dad75788d367f4651408.png";